import { render } from "./Cookie-Bar.vue?vue&type=template&id=84b458a4"
import script from "./Cookie-Bar.vue?vue&type=script&lang=js"
export * from "./Cookie-Bar.vue?vue&type=script&lang=js"

import "./Cookie-Bar.vue?vue&type=style&index=0&id=84b458a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__